// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"025c2021","673":"f74474b9","767":"7a890158"}[chunkId] + ".chunk.js";
};